
    import AlertConfirmModal from '@/components/alert-confirm/alert-confirm-modal.vue';
    import Vue from 'vue';  

    export default Vue.extend({
        name: "AlertConfirmDialog",
        components: { 
            'alert-confirm-modal': AlertConfirmModal 
        },
        data: () => ({
            title: undefined as string|undefined,
            message: undefined as string|undefined, 
            yesButton: 'Yes' as string|undefined, 
            noButton: 'No' as string|undefined,   
            isAlert: false as boolean,
            resolvePromise: undefined as any|undefined
        }),
        methods: {
            _yes() {
                (this.$refs.confirm as any).close();
                if (this.resolvePromise) this.resolvePromise(true);
            },
            _no() {
                (this.$refs.confirm as any).close();
                if (this.resolvePromise) this.resolvePromise(false); 
            }
        },
        created() {
            // this is how the alert/confirm is shown, via the eventbus
            this.$modalBus.$on("show-alert-confirm", (options: IAlertConfirmDialogOptions, resolve) => {

                this.isAlert = options.isAlert;
                this.title = options.title;
                this.message = options.message;

                if (options.yesButton) {
                    this.yesButton = options.yesButton;
                }

                if (!this.isAlert) {
                    if (options.noButton) {
                        this.noButton = options.noButton;
                    }
                }
                else {
                    this.yesButton = "Ok";
                }

                (this.$refs.confirm as any).open();

                // resolve the promise
                this.resolvePromise = resolve;
            });
        }
    });
